// set path from where to load dynamic assets from webpack-built javascript bundles
__webpack_public_path__ = window.gotoAndPlay.assetsPath;
